import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getReportIssue,
  getIdReportIssue,
  createReportIssue,
  updateReportIssue,
  deleteReportIssue,
  updateReportIssueAll,
  createReportIssueUpload,
  getFileBlob,
  getFile,
  createReportIssueUploadResolve,
  getReportIssueDownload,
} from "./reportIssueAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchReportIssue = createAsyncThunk(
  "ReportIssue/fetchReportIssue",
  async (payload) => {
    const response = await getReportIssue(payload);
    return response;
  }
);

export const addReportIssue = createAsyncThunk(
  "ReportIssue/addReportIssue",
  async (payload) => {
    const response = await createReportIssue(payload);
    return response;
  }
);

export const addReportIssueUpload = createAsyncThunk(
  "ReportIssue/addReportIssueUpload",
  async ({ id, file }) => {
    const response = await createReportIssueUpload(id, file);
    return response;
  }
);
export const addReportIssueUploadResolve = createAsyncThunk(
  "ReportIssue/addReportIssueUpload",
  async ({ id, file }) => {
    const response = await createReportIssueUploadResolve(id, file);
    return response;
  }
);
export const editReportIssue = createAsyncThunk(
  "ReportIssue/editReportIssue",
  async (payload) => {
    const response = await updateReportIssue(payload);
    return response;
  }
);

export const editReportIssueAll = createAsyncThunk(
  "ReportIssue/editReportIssueAll",
  async (payload) => {
    const response = await updateReportIssueAll(payload);
    return response;
  }
);

export const fetchIdReportIssue = createAsyncThunk(
  "ReportIssue/fetchIdReportIssue",
  async (id) => {
    const response = await getIdReportIssue(id);
    return response;
  }
);

export const removeReportIssue = createAsyncThunk(
  "ReportIssue/removeReportIssue",
  async (payload) => {
    const response = await deleteReportIssue(payload);
    return response;
  }
);

// get template
export const fetchFile = createAsyncThunk(
  "reporting/fetchFile",
  async (payload) => {
    const response = await getFile(payload);
    return response;
  }
);
export const fetchFileBlob = createAsyncThunk(
  "reporting/fetchFileBlob",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const fetchReportIssueDownload = createAsyncThunk(
  "ReportIssue/reportIssueDownload",
  async (payload) => {
    const response = await getReportIssueDownload(payload);
    return response;
  }
);

export const reportIssueSlice = createSlice({
  name: "reportIssue",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchIdReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(addReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addReportIssueUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(addReportIssueUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(editReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editReportIssueAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(editReportIssueAll.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeReportIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeReportIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFileBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFileBlob.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchReportIssueDownload.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportIssueDownload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = reportIssueSlice.actions;

export const selectReportIssue = (state) => state.reportIssue.data;
export const selectIdReportIssue = (state) => state.reportIssue.dataId;
export const selectLoading = (state) => state.reportIssue.loading;
export const selectError = (state) => state.reportIssue.error;
export const selectPageNo = (state) => state.reportIssue.pageNo;
export const selectPageSize = (state) => state.reportIssue.pageSize;
export const selectTotalRecord = (state) => state.reportIssue.totalRecord;
export const selectSelected = (state) => state.reportIssue.selected;
export const selectResult = (state) => state.reportIssue.result;

export default reportIssueSlice.reducer;
